import request from '@/blocks/request';

export function getCityList(params) {
  return request({
    baseURL: process.env.VUE_APP_PANGKU_API,
    url: `/v1/comm/location/cities`,
    params,
  });
}

export function ipGeolocation(params) {
  return request({
    baseURL: `https://restapi.amap.com`,
    url: `/v3/ip`,
    params: {
      key: 'd245ef0c8a8a82419f15128fd9a16789',
      ...params,
    },
  });
}
